import { ChangeCandidateDto } from '../change-candidate-dto';
import { PackagingUnitDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-dto';

export class ChangePackagingUnitCandidateDto extends ChangeCandidateDto {
    updatedPackagingUnit!: PackagingUnitDto;
    existingPackagingUnit!: PackagingUnitDto;
}
